/* global axios */
import ApiClient from '../ApiClient';

class OnixFlowsAPI extends ApiClient {
  constructor() {
    super('onix/flows', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  playground(id, data) {
    return axios.post(`${this.url}/${id}/playground`, data);
  }
}

export default new OnixFlowsAPI();
